function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { SpinnerContainer, StyledSpinner, StyledSpinnerMessage, StyledSpinnerBackground, SpinnerIconContainer } from './Spinner.style';
import { ScreenReaderOnly } from '../../foundation/Typography/ScreenReaderOnly';
import { getCleanProps } from '../../utility/getCleanProps';
import PropTypes from 'prop-types';
var componentId = 'Spinner';
Spinner.propTypes = {
  /** Size of the spinner */
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /** Message text that gets displayed under the spinner */
  message: PropTypes.string,

  /** Is this spinner being used on a dark background */
  isOnDarkBg: PropTypes.bool,

  /** ref to this spinner */
  itemRef: PropTypes.shape({
    current: PropTypes.any
  }),

  /** Screen reader text if the spinner is not accompanied with any message */
  srText: PropTypes.string,

  /** Is this spinner to be displayed inline */
  isInline: PropTypes.bool
};
Spinner.defaultProps = {
  /** Default size of spinner is small */
  size: 'sm',
  isOnDarkBg: false,
  isInline: false
};
Spinner.componentId = componentId;
export function Spinner(props) {
  var size = props.size,
      message = props.message,
      isOnDarkBg = props.isOnDarkBg,
      srText = props.srText,
      itemRef = props.itemRef,
      isInline = props.isInline,
      restProps = _objectWithoutProperties(props, ["size", "message", "isOnDarkBg", "srText", "itemRef", "isInline"]);

  return /*#__PURE__*/React.createElement(SpinnerContainer, _extends({}, getCleanProps(restProps), {
    ref: itemRef,
    inline: isInline,
    "data-component-id": componentId
  }), /*#__PURE__*/React.createElement(SpinnerIconContainer, {
    size: size,
    darkBg: isOnDarkBg,
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(StyledSpinnerBackground, {
    size: size,
    darkBg: isOnDarkBg,
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(StyledSpinner, {
    size: size,
    darkBg: isOnDarkBg,
    "aria-hidden": "true"
  })), message && /*#__PURE__*/React.createElement(StyledSpinnerMessage, {
    darkBg: isOnDarkBg,
    inline: isInline
  }, message), srText && /*#__PURE__*/React.createElement(ScreenReaderOnly, null, srText));
}